<template>
  <div class="absolute step-list">
    <div class="step-list__title">
      <span class="text-white text-20px list-title">步骤列表</span>
    </div>
    <el-card shadow="never" class="mt-10px step-list__content">
      <div
        class="step-item"
        v-for="(item, index) in executeSteps"
        :key="item.id"
        @click="chooseStep(index)"
        :class="{
          current: currentStepIndex === index,
          executed: operateType % 2 === 0 ? currentStepIndex < index : currentStepIndex > index,
          choose: showJump && chooseIndex === index,
        }"
      >
        {{ item.name }}
      </div>
    </el-card>
    <div class="mt-15px" v-if="isShowMsg && !isAssessMode">
      <el-button
        type="primary"
        size="small"
        @click="stepJump"
        v-if="showJump && isShowMsg && !isAssessMode"
        >步骤跳转</el-button
      >
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data() {
    return {
      activeStep: '',
      chooseIndex: -1,
      audioMsg: null, // 播放音频的对象信息
    }
  },
  props: {
    player: {
      type: Object,
      default: null,
    },
    // 方案列表
    steps: {
      type: Array,
      default: () => {
        return []
      },
    },
    currentStepIndex: {
      type: Number,
      default: -1,
    },
    operateType: {
      type: Number,
      default: -1,
    },
    isAssessMode: {
      type: Boolean,
      default: false,
    },
    isShowMsg: {
      type: Boolean,
      default: false,
    },
    showJump: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    executeSteps: {
      get() {
        return this.steps
      },
      set() {},
    },
  },
  watch: {
    currentStepIndex(val) {
      console.log(_.trim(this.executeSteps[val]?.assembleyRemark), '---val---')
      if (this.operateType % 2 === 0 && _.trim(this.executeSteps[val]?.assembleyRemark)) {
        this.handleSpeak(this.executeSteps[val].assembleyRemark)
        return
      }
      if (this.operateType % 2 !== 0 && _.trim(this.executeSteps[val]?.disAssembleyRemark)) {
        this.handleSpeak(this.executeSteps[val].disAssembleyRemark)
      }
    },
  },
  created() {
    this.audioMsg = new SpeechSynthesisUtterance()
  },
  beforeDestroy() {
    this.stopSpeak()
  },
  methods: {
    // 音频播放方法
    handleSpeak(text) {
      // 播放语音前，停止上一次的播放
      this.stopSpeak(text)
      this.audioMsg.text = text
      this.audioMsg.lang = 'zh-CN' // 使用的语言：中文
      this.audioMsg.volume = 0.8 // 声音音量
      this.audioMsg.rate = 1 // 语速
      this.audioMsg.path = 1 // 音高
      window.speechSynthesis.speak(this.audioMsg)
    },
    // 暂停音频的方法
    stopSpeak(e) {
      this.audioMsg.text = e
      this.audioMsg.lang = 'zh-CN'
      window.speechSynthesis.cancel(this.audioMsg)
    },
    // 步骤跳转
    stepJump() {
      if (this.chooseIndex >= 0) {
        this.$emit('stepJump', this.chooseIndex)
      } else {
        this.$message.warning('请选择要跳转的步骤')
      }
    },
    chooseStep(index) {
      if (this.showJump && this.isShowMsg && !this.isAssessMode) {
        this.chooseIndex = index
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../css/base';
.step-list {
  right: 10px;
  top: 90px;
  height: calc(100% - 110px) !important;
  width: 400px;
  z-index: 100;
  padding: 10px;
  background-color: #2e6bb07f !important;
  &__content {
    height: calc(100% - 120px) !important;
    width: 100%;
    background-color: #ffffff00;
    border: none !important;
  }
  .list-title {
    font-weight: bold;
    background-image: -webkit-repeating-linear-gradient(top, #fff, #dce7f3, #6fb6f9);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.step-list__content {
  background-color: #2e6bb07f !important;
  .step-item {
    color: white;
    padding: 10px 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    &.current {
      color: #48e663 !important;
    }
    &.executed {
      color: #abadb1 !important;
    }
    &.choose {
      background-color: #073060 !important;
    }
  }
}
::v-deep .el-card__body {
  height: 100% !important;
  overflow-y: auto !important;
  padding: 15px !important;
  &::-webkit-scrollbar {
    background-color: transparent !important;
    width: 9px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(37, 36, 36, 0.8) !important;
    color: rgb(37, 36, 36) !important;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: rgba(218, 213, 213, 0.1) !important;
  }
}
::v-deep.el-button--small {
  width: 80px !important;
}
</style>
